package core.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 01.04.20
 * Author : mariorosshirt
 */
@Serializable
enum class ESponsorPreviewTypeDB {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    @SerialName("IMAGE")
    IMAGE,

    @SerialName("IMAGE_AND_TEXT")
    IMAGE_AND_TEXT,

    @SerialName("GIF")
    GIF,

    @SerialName("GAME_LIKE")
    GAME_LIKE

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}